import React from 'react';

// eslint-disable-next-line new-cap
const MapContext = new React.createContext();
export default MapContext;
